export default __webpack_public_path__ + "static/media/March_07.799aab3c.png";